import React from 'react'

const PageTitle = (props) => (
  <h1
    className="mui--text-dark-secondary"
    style={{display: 'flex', alignItems: 'center'}}
  >
    {props.children}
  </h1>
)

export default PageTitle



// WEBPACK FOOTER //
// ./src/components/UI/PageTitle.jsx